<template>
  <TextField
    id="mealplan-id"
    :name="`${formNamespace}id`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.planId')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.planIdPlaceholder')"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TextField } from '@centric-os/components/src/composed/validators/text-field';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

const { t } = useI18n();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
